import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 23 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 27\" id=\"lock\"><path fill-rule=\"evenodd\" d=\"M3.938 7.313v3.937H2.25A2.25 2.25 0 0 0 0 13.5v11.25A2.25 2.25 0 0 0 2.25 27h18a2.25 2.25 0 0 0 2.25-2.25V13.5a2.25 2.25 0 0 0-2.25-2.25h-1.688V7.313a7.313 7.313 0 0 0-14.624 0zM6.75 11.25v-4.2c0-2.652 2.014-4.8 4.5-4.8s4.5 2.148 4.5 4.8v4.2h-9zM9 18a2.25 2.25 0 1 1 3.47 1.89s.22 1.328.468 2.891a.843.843 0 0 1-.844.844h-1.688a.843.843 0 0 1-.843-.844l.466-2.89A2.247 2.247 0 0 1 9 18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol